import { createFileRoute } from '@tanstack/react-router';
import { ArtifactsListPage } from '@/pages/organization/artifacts/ArtifactsListPage';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/$slug/organization/artifacts/')({
  component: ArtifactsListPage,
  validateSearch: dataTableSearchSchema({})
});
